<template>
  <vs-row vs-justify="center">
    <!-- /////////////////////////////////////////////
    Email Campaigns
    /////////////////////////////////////////////-->
    <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <vs-card class="active-user-card">
        <QueuesSummary :data="reports.queues"></QueuesSummary>
      </vs-card>
    </vs-col>
    <!-- /////////////////////////////////////////////
    Active Visitors
    /////////////////////////////////////////////-->
    <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <vs-card class="active-user-card">
        <BookingsSummary :data="reports.bookings"></BookingsSummary>
      </vs-card>
    </vs-col>
    <!-- /////////////////////////////////////////////
    Revenue Statistics
    /////////////////////////////////////////////-->
    <vs-col vs-lg="4" vs-xs="12" vs-sm="12">
      <FeedbackSummary
        v-if="feedbackSummary && feedback && rating"
        id="feedback-listing"
        :data="feedbackSummary"
        :total="feedback"
        :rating="rating"
      ></FeedbackSummary>
    </vs-col>

    <!-- /////////////////////////////////////////////
    Revenue Statistics
    /////////////////////////////////////////////-->

    <ServicePieChart
      :headerTitle="$t('Statistics.ServiceFrequency.ServicesPie')"
    />

    <!-- /////////////////////////////////////////////
    Revenue Statistics
    /////////////////////////////////////////////-->

    <FrequencyCharts
      :businessArray="selected_business"
      :headerTitle="$t('Statistics.Tabs.Frequency.Chart.Daily')"
      :visitFrequencyParams="{
        periodical: 'DAILY',
        business_id: selected_business,
      }"
    />

    <vs-popup
      :active.sync="onBoardingActive"
      title="Welcome to Liberrex"
      class="onboarding"
    >
      <div>
        <vs-row>
          <vs-col vs-w="12" class="text-center">
            <h2 class="text-primary mb-2">
              {{ $t("Dashboard.OnBoarding.Title") }}
            </h2>
            <p class="p-0 text-cyan">
              {{ $t("Dashboard.OnBoarding.Text") }}
            </p>
            <p class="p-2 text-cyan">
              <img
                :src="require('@/assets/images/placeholder/welcome.jpg')"
                class="welcome-img"
              />
            </p>
            <vs-row>
              <vs-col class="mt-2">
                <vs-button
                  class="w-50 text-uppercase"
                  color="primary"
                  size="large"
                  @click="
                    onBoardingActive = false;
                    showQuickSetup();
                  "
                >
                  {{ $t("Dashboard.OnBoarding.SetupButton") }}
                </vs-button>
              </vs-col>
              <vs-col class="mt-2">
                <vs-button
                  class="w-50 text-uppercase"
                  color="dark"
                  type="border"
                  size="large"
                  @click="onBoardingActive = false"
                >
                  {{ $t("Dashboard.OnBoarding.LaterButton") }}
                </vs-button>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>

    <QuickSetupModal ref="QuickSetupModal"></QuickSetupModal>
  </vs-row>
</template>
<script>
// //////////////////////////////////////////
// Import Components Here
// //////////////////////////////////////////
import QueuesSummary from "../../components/widgets/dashboard/QueuesSummary";
import BookingsSummary from "../../components/widgets/dashboard/BookingsSummary";
import FeedbackSummary from "../../components/widgets/feedback/FeedbackSummary";
import PieChart from "../../components/chartjs/PieChart";
import ServicePieChart from "../../components/statistics/ServicePieChart";
import FrequencyCharts from "../../components/statistics/FrequencyCharts";
import LineChart from "../../components/chartjs/LineChart";
import { statisticsService } from '../../_services/feedback.service';
import { feedbackService } from '../../_services/feedback.service';
import { mapState } from "vuex";
import router from "../../_helpers/router";
import QuickSetupModal from "../../components/onboarding/QuickSetupModal";

// //////////////////////////////////////////
// Export Here
// //////////////////////////////////////////
export default {
  name: "ClassicDashboard",
  data: () => ({
    selected_business: null,
    title: "ClassicDashboard",
    titleEn: "Click here to open user profile menu.",
    // Month Table
    onBoardingActive: false,
    rating: 0,
    month1: 0,
    monthoptions1: [
      { text: "Monthly", value: 0 },
      { text: "Daily", value: 1 },
      { text: "Weekly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    feedbackSummary: {},
    feedback: [],
    reports: {
      bookings: {},
      queues: {},
      services: [],
      visits: {},
    },
    steps: [
      {
        target: "#feedback-listing", // We're using document.querySelector() under the hood
        params: {
          placement: "auto", // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
        },
      },
      {
        target: "#profile-menu", // We're using document.querySelector() under the hood
        header: {
          title: "Profile Menu",
        },
        modifiers: {
          arrow: {
            element: ".v-step__arrow",
          },
        },
        params: {
          placement: "left",
        },
      },
      {
        target: "#lang-box",
        params: {
          placement: "bottom-start",
        },
      },
      {
        target: "#notifications-popup",
        params: {
          placement: "bottom-end",
        },
      },
    ],
  }),
  methods: {
    goToNextPage() {
      router.push({ path: "/queues?istour=on" });
    },
    skipTour() {
      localStorage.setItem("skipTour", "true");
      this.$tours["Dashboard"].stop();
    },
    showQuickSetup() {
      this.$refs.QuickSetupModal.show();
    },
  },
  components: {
    QueuesSummary,
    BookingsSummary,
    FeedbackSummary,
    PieChart,
    LineChart,
    QuickSetupModal,
    ServicePieChart,
    FrequencyCharts,
  },
  mounted() {
    feedbackService.getAll().then(
      function (data) {
        this.feedbackSummary = data.customers_satisfaction;
        this.feedback = data.feedback.total;
        this.rating = data.rating;
        this.$t("Components.Feedback.Content").map(
          (content, index) => (this.steps[index].content = content)
        );
      }.bind(this)
    );
    statisticsService.home().then(
      function (data) {
        this.reports = data.reports.web;
      }.bind(this)
    );
    this.onBoardingActive = this.$route.query.onboarding ? true : false;
    this.$t("Dashboard.Content").map(
      (content, index) => (this.steps[index].content = content)
    );
    localStorage.getItem("skipTour") != "true"
      ? this.$tours["Dashboard"].start()
      : "";
    window.scrollTo(20, 0);
  },
  computed: {
    ...mapState({
      account_info: (state) => state.account.user.user,
      business_info: (state) => state.account.user.business,
    }),
  },
};
</script>
<style>
.onboarding .vs-popup--header {
  display: none !important;
}
.onboarding .welcome-img {
  max-height: 50%;
  max-width: 300px;
  width: 100%;
}
</style>